<template>
    <div class="tnkc-timeline-app" id="calendar">
        <FullCalendar :options="calendarOptions"></FullCalendar>
    </div>
</template>

<script>
  import FullCalendar from '@fullcalendar/vue'
  import resourceTimeline from '@fullcalendar/resource-timeline';
  import interaction from '@fullcalendar/interaction';
  import {GPL_FOR_DEVS_LICENSE} from '../../service/gplkey.service';
  import {INITIAL_EVENTS} from '../../service/event-utils';

  export default {
    name: 'Timeline',
    components:{
      FullCalendar
    },
    data(){
      return {
        aspectRatio: 1.5,
        calendarOptions : {
          scrollTime: '08:00',
          height: 600,
          plugins:[
            resourceTimeline,interaction
          ],

          headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth'
          },
          resourceAreaHeaderContent: 'Rooms',


          initialView: 'resourceTimelineMonth',

          schedulerLicenseKey: GPL_FOR_DEVS_LICENSE,

          resources: [
            { id: 'a', building: '460 Bryant', title: 'Auditorium A'},
            { id: 'l', building: '564 Pacific', title: 'Auditorium L'},
            { id: 'm', building: '564 Pacific', title: 'Auditorium M' },
            { id: 'n', building: '564 Pacific', title: 'Auditorium N' },
            { id: 'o', building: '101 Main St', title: 'Auditorium O' },
            { id: 'p', building: '101 Main St', title: 'Auditorium P' },
            { id: 'q', building: '101 Main St', title: 'Auditorium Q' },
            { id: 'r', building: '101 Main St', title: 'Auditorium R' },
            { id: 's', building: '101 Main St', title: 'Auditorium S' },
            { id: 't', building: '101 Main St', title: 'Auditorium T' },
            { id: 'u', building: '101 Main St', title: 'Auditorium U' },
            { id: 'v', building: '101 Main St', title: 'Auditorium V',
              "children": [
                {
                  "id": "d1",
                  "title": "Room D1"
                },
                {
                  "id": "d2",
                  "title": "Room D2"
                }
              ]
            },
            { id: 'w', building: '101 Main St', title: 'Auditorium W' },
            { id: 'x', building: '101 Main St', title: 'Auditorium X' },
            { id: 'y', building: '101 Main St', title: 'Auditorium Y' },
            { id: 'z', building: '101 Main St', title: 'Auditorium Z' }
          ],
          events: [
            {
              resourceId: "d1",
              title: "event 3",
              // end: "2020-11-27T06:00:00+00:00",
              // start: "2020-11-01T00:00:00+00:00",
              start: "2020-11-01",
              end: "2020-11-15",
              backgroundColor: '#8BBDDE',

              extendedProps: {
                department: 'BioChemistry'
              }
            }
          ]

        },
      }
    }
  };
</script>

<style scoped>

    .tnkc-timeline-app{
        flex-grow: 1;
        padding: 2em;
        max-width: 1100px;
        margin: 40px auto;
    }

    /*div.fc-event-title fc-sticky{*/
    /*    color: #a0daff !important;*/
    /*}*/

</style>

<style>
    .fc-datagrid-cell-main{
        font-weight: bold !important;
    }

    .fc-cell-text
    {
        color: white !important;
    }

    .fc-event-title{
        color: white!important;
    }
</style>